<template>
    <v-menu
        v-model="show"
        :position-x="x"
        :position-y="y"
        absolute
        offset-y
        :close-on-content-click="false"
    >
        <div class="menu-content-container">
            <v-layout align-center class="pa-2">
                <img :src="NodeIconMap[NodeType.PORTAL]" alt="icon">
                <input type="text" v-model="search" ref="input">
            </v-layout>
            <div class="item-group-container">
                <v-layout
                    align-center
                    v-for="item in filterItemList"
                    :key="item.id"
                    @click="select(item)"
                    class="item-container"
                >
                    <img :src="NodeIconMap[item.type]" alt="icon">
                    {{item.name}}
                </v-layout>
            </div>
        </div>
    </v-menu>
</template>

<script>
import { mapState } from "vuex";
import ScenarioService from "@/services/scenario.service";

const { NodeIconMap, NodeType } = ScenarioService

export default {
    name: "ScenarioNodeSelectorMenu",
    data () {
        return {
            show: false,
            x: 0,
            y: 0,
            search: '',
            itemList: [],
            promise: {
                resolve: null,
                reject: null
            },
            NodeIconMap,
            NodeType
        }
    },
    computed: {
        ...mapState({
            nodeList: state => {
                let list = state.scenario.treeData ? [...state.scenario.treeData.nodeList] : []
                return list.sort((a, b) => a.name.localeCompare(b.name))
            }
        }),
        filterItemList () {
            let search = this.search.trim().toLowerCase()
            return this.itemList.filter(node => (
                this.$utils.nonAccentVietnamese(node.name).includes(search) ||
                node.id.includes(search)
            ))
        }
    },
    methods: {
        open (node, nodeList) {
            if (nodeList) {
                if (nodeList.length === 0) {
                    this.$appService.toastInfo('no node available to select')
                } else if (nodeList.length === 1) {
                    return Promise.resolve(nodeList[0])
                } else {
                    this.itemList = nodeList
                    let el = document.getElementById('fp-' + node.id)
                    let viewport = el.getBoundingClientRect()
                    this.x = viewport.left
                    this.y = viewport.top
                    this.show = true
                    setTimeout(() => {
                        this.$refs.input.focus()
                    }, 100)
                }
            } else {
                this.$appService.toastError('require nodeList')
            }
            return new Promise((resolve, reject) => {
                this.promise = { resolve, reject }
            })
        },
        select (node) {
            this.search = ''
            this.promise.resolve(node)
            this.show = false
        }
    }
}
</script>

<style scoped lang="scss">
    .menu-content-container {
        background: #fff;
        font-size: 14px;

        img {
            width: 20px;
            height: 20px;
            margin-right: 10px;
        }

        .item-group-container {
            width: 300px;
            height: 300px;
            overflow: auto;
        }
    }

    input {
        border: 1px solid #B2B4C6;
        height: 30px;
        width: 120px;
        border-radius: 50px;
        padding: 5px;
        flex-grow: 1;

        &:focus {
            outline: none;
            border-color: #0052CC;
        }
    }

    .item-container {
        padding: 10px;
        cursor: pointer;
        border-top: 1px solid #EDEDF2;

        &:hover {
            background: #ccc;
        }
    }
</style>
